export default {
  accountLogin: 'Account Log In',
  checkTips: 'Please read and agree to the Privacy Notice.',
  confirmTips: 'I have reed and agree to the HeyTap Account Privacy Notice.',
}